import { jsx as o, jsxs as t } from "@emotion/react/jsx-runtime";
import { Stack as c, Text as a, Icon as s, FontAwesomeIconsPartooUsed as d, IconPrefix as l } from "@partoohub/ui";
import { OverrideButton as p } from "../../../BusinessModalButton.styled.js";
const h = ({
  dataTrackId: e,
  buttonText: r,
  disabled: n = !1,
  onClick: i
}) => /* @__PURE__ */ o(p, { dataTrackId: e, appearance: "outlined", shape: "cube", size: "large", disabled: n, onClick: i, children: /* @__PURE__ */ t(c, { gap: "24px", direction: "row", alignItems: "center", children: [
  /* @__PURE__ */ o(a, { variant: "bodyMSemibold", as: "div", color: "secondary", children: r }),
  /* @__PURE__ */ o(s, { icon: [d.faChevronRight, l.SOLID], color: "secondary", iconSize: "12px" })
] }) });
export {
  h as FilterButton
};
